import { BaseModel } from "sjs-base-model";

export default class InfluencerQuoraPlatformPostModel extends BaseModel {
  data = [];
  id = "";
  status = "";

  constructor(data) {
    super();

    this.update(data);
  }
}
